import * as _ from 'lodash'
import {
  IDimension, IDimensionDataProvider, IDimensionSelector, IHierarchy, IHierarchyLevel,
  IHierarchyNode
} from "../PA.Reporting.Core/PA.Reporting.IF";
import {ASync} from "../PA.Core/Basic/ASync";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {DimensionSelector} from "../PA.Reporting.Core/DimensionSelector";

export class MockDimensionDataProvider
  implements  IDimensionDataProvider
{

  getHierarchies(): Promise<IHierarchy[]> {

    let returnValue: IHierarchy[] = []

    returnValue.push({HierarchyId: "H1",
                      HierarchyName: "Hierarchy One",
                      HierarchyDescription: "First Hierarchy"})

    returnValue.push({HierarchyId: "H2",
      HierarchyName: "Hierarchy Two",
      HierarchyDescription: "Second Hierarchy"})

    return ASync.resolve(returnValue)

  }

  getHierarchyLevels(HierarchyId: string): Promise<IHierarchyLevel[]> {
    return ASync.resolve([]);
  }

  getHierarchyNodes(HierarchyId: string, level_count?: number): Promise<IHierarchyNode[]> {

    let returnValue: IHierarchyNode[] = []

    switch(HierarchyId){
      case 'H1':
        returnValue.push({NodeId: 'P1', NodeIdUI: 'P1',  NodeLevel: '', NodeName: 'Node P1',NodeShortName: 'NodeP1', ParentId: undefined})
        returnValue.push({NodeId: 'C1', NodeIdUI: 'C1', NodeLevel: '', NodeName: 'Node C1',NodeShortName: 'NodeC1', ParentId: 'P1'})
        returnValue.push({NodeId: 'C2', NodeIdUI: 'C2', NodeLevel: '', NodeName: 'Node C2',NodeShortName: 'NodeC2', ParentId: 'P1'})
        returnValue.push({NodeId: 'C2-1', NodeIdUI: 'C2-1', NodeLevel: '', NodeName: 'Node C2-1',NodeShortName: 'NodeC2-1', ParentId: 'C2'})

        returnValue.push({NodeId: 'P2', NodeIdUI: 'P2', NodeLevel: '', NodeName: 'Node P2',NodeShortName: 'NodeP1', ParentId: undefined})
        returnValue.push({NodeId: 'X1', NodeIdUI: 'X1', NodeLevel: '', NodeName: 'Node X1',NodeShortName: 'NodeX1', ParentId: 'P2'})
        returnValue.push({NodeId: 'X2', NodeIdUI: 'X2', NodeLevel: '', NodeName: 'Node X2',NodeShortName: 'NodeX2', ParentId: 'P2'})
        break;

      case 'H2':
        returnValue.push({NodeId: 'H2-P1', NodeIdUI: 'H2-P1', NodeLevel: '', NodeName: 'H2 Node P1',NodeShortName: 'H2 NodeP1', ParentId: undefined})
        returnValue.push({NodeId: 'H2-C1', NodeIdUI: 'H2-C1', NodeLevel: '', NodeName: 'H2 Node C1',NodeShortName: 'H2 NodeC1', ParentId: 'H2-P1'})
        returnValue.push({NodeId: 'H2-C2', NodeIdUI: 'H2-C2', NodeLevel: '', NodeName: 'H2 Node C2',NodeShortName: 'H2 NodeC2', ParentId: 'H2-P1'})

        returnValue.push({NodeId: 'H2-P2', NodeIdUI: 'H2-P1', NodeLevel: '', NodeName: 'H2 Node P2',NodeShortName: 'H2 NodeP1', ParentId: undefined})
        returnValue.push({NodeId: 'H2-X1', NodeIdUI: 'H2-X1', NodeLevel: '', NodeName: 'H2 Node X1',NodeShortName: 'H2 NodeX1', ParentId: 'H2-P2'})
        returnValue.push({NodeId: 'H2-X2', NodeIdUI: 'H2-X2', NodeLevel: '', NodeName: 'H2 Node X2',NodeShortName: 'H2 NodeX2', ParentId: 'H2-P2'})

        break;

    }

    return ASync.resolve(returnValue)

  }
}

export class MockDimensionSelector extends DimensionSelector
{

  constructor(pDimension?: IDimension) {

    let aDimension = {
      DimensionId: 'MockId',
      DimensionName: 'MockName',
      DimensionTechnicalName: 'MockTechName',
      DimensionRenderOptions: {}
    }

    let aDimensionDataProvider = new MockDimensionDataProvider()

    super(pDimension || aDimension, aDimensionDataProvider,'',[])

  }

}